import {
  titleUI,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import PermanentDisabilityDescription from '../../../components/PermanentDisabilityDescription';
import { isClaimantSchoolAge, isClaimant18OrOlder } from '../../utils/helpers';

export default {
  uiSchema: {
    ...titleUI('Additional information'),
    childInSchool: yesNoUI({
      title: 'Are you still in school?',
      required: isClaimantSchoolAge,
      hideIf: formData => !isClaimantSchoolAge(formData),
    }),
    childSeriouslyDisabled: yesNoUI({
      title:
        'Do you have a permanent disability that prevents you from caring for yourself?',
      required: isClaimant18OrOlder,
      hideIf: formData => !isClaimant18OrOlder(formData),
    }),
    childPreviouslyMarried: yesNoUI({
      title: 'Have you ever been married?',
    }),
    'view:permanentDisabilityDescription': {
      'ui:description': PermanentDisabilityDescription,
      'ui:options': {
        hideIf: formData => !isClaimant18OrOlder(formData),
      },
    },
  },
  schema: {
    type: 'object',
    required: ['childPreviouslyMarried'],
    properties: {
      childInSchool: yesNoSchema,
      childSeriouslyDisabled: yesNoSchema,
      childPreviouslyMarried: yesNoSchema,
      'view:permanentDisabilityDescription': {
        type: 'object',
        properties: {},
      },
    },
  },
};
